import { useMemo, useState } from 'react';
import axiosInstance from '../store/api';
import { useAuthStore } from '../store/authStore';

export function useAppTrialAccess(appKey) {
  const user = useAuthStore(state => state.user);
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const config = user?.apps; // si lo tienes global
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const trialUsed = useMemo(() => {
    return !!config?.[appKey]?.trial?.used;
  }, [config, appKey]);

  const access = user?.apps?.[appKey] || user?.appsAccess?.[appKey];

  const hasActiveAccess = useMemo(() => {
    if (!access || !access.enabled || !access.expiresAt) return false;
    return new Date(access.expiresAt) > new Date();
  }, [access]);

  const canRequestTrial = useMemo(() => {
    return isAuthenticated && !hasActiveAccess && !trialUsed;
  }, [isAuthenticated, hasActiveAccess, trialUsed]);

  const mustRenew = useMemo(() => {
    return isAuthenticated && !hasActiveAccess && trialUsed;
  }, [isAuthenticated, hasActiveAccess, trialUsed]);

  const startTrial = async () => {
    if (!canRequestTrial) return;

    try {
      setLoading(true);
      setError(null);

      await axiosInstance.post(`/users/apps/${appKey}/free-trial`);

      // 🔄 refrescamos datos del usuario
      window.location.reload();
    } catch (e) {
      setError(
        e.response?.data?.message || 'No se pudo activar el demo'
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    isAuthenticated,
    hasActiveAccess,
    canRequestTrial,
    mustRenew,
    startTrial,
    loading,
    error
  };
}
